var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('contact-form',{attrs:{"loading":_vm.loading,"contactData":_vm.contact,"formErrors":_vm.formErrors},on:{"contactSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }